import _defineProperty from "/builder/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builder/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, ExtensionPriority, keyBinding, NamedShortcut, command, MarkExtension, ExtensionTag, isElementDomNode, includes, omitExtraAttributes, getMarkRange, getSelectedWord, isTextSelection, isSelectionEmpty, isAllSelection, isMarkActive, updateMark, removeMark, getMatchString, preserveSelection, range } from '@remirror/core';
import { TextSelection } from '@remirror/pm/state';
import { isInvalidSplitReason, isRemovedReason } from '@remirror/pm/suggest';
var _excluded = ["auto", "target"];

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2;

var UPDATE_LINK = 'updateLink';
/**
 * Can be an empty string which sets url's to '//google.com'.
 */

var LinkExtension = (_dec = extension({
  defaultOptions: {
    autoLink: false,
    defaultProtocol: '',
    selectTextOnClick: false,
    openLinkOnClick: false,
    // Based on https://gist.github.com/dperini/729294
    autoLinkRegex: /(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?:[\da-z\u00A1-\uFFFF][\w\u00A1-\uFFFF-]{0,62})?[\da-z\u00A1-\uFFFF]\.)+[a-z\u00A1-\uFFFF]{2,}\.?(?::\d{2,5})?(?:[#/?]\S*)?/gi,
    defaultTarget: null,
    supportedTargets: [],
    extractHref: extractHref
  },
  staticKeys: ['autoLinkRegex'],
  handlerKeyOptions: {
    onClick: {
      earlyReturnValue: true
    }
  },
  handlerKeys: ['onActivateLink', 'onShortcut', 'onUpdateLink', 'onClick'],
  defaultPriority: ExtensionPriority.Medium
}), _dec2 = keyBinding({
  shortcut: NamedShortcut.InsertLink
}), _dec3 = command(), _dec4 = command(), _dec5 = command(), _dec(_class = (_class2 = /*#__PURE__*/function (_MarkExtension) {
  _inherits(LinkExtension, _MarkExtension);

  var _super = _createSuper(LinkExtension);

  function LinkExtension() {
    _classCallCheck(this, LinkExtension);

    return _super.apply(this, arguments);
  }

  _createClass(LinkExtension, [{
    key: "name",
    get: function get() {
      return 'link';
    }
  }, {
    key: "createTags",
    value: function createTags() {
      return [ExtensionTag.Link, ExtensionTag.ExcludeInputRules];
    }
  }, {
    key: "createMarkSpec",
    value: function createMarkSpec(extra, override) {
      var _this = this;

      var _override$parseDOM;

      var AUTO_ATTRIBUTE = 'data-link-auto';

      var getTargetObject = function getTargetObject(target) {
        var _this$options = _this.options,
            defaultTarget = _this$options.defaultTarget,
            supportedTargets = _this$options.supportedTargets;
        var targets = defaultTarget ? [].concat(_toConsumableArray(supportedTargets), [defaultTarget]) : supportedTargets;
        return target && includes(targets, target) ? {
          target: target
        } : undefined;
      };

      return _objectSpread(_objectSpread({
        inclusive: false,
        excludes: '_'
      }, override), {}, {
        attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
          href: {},
          target: {
            default: this.options.defaultTarget
          },
          auto: {
            default: false
          }
        }),
        parseDOM: [{
          tag: 'a[href]',
          getAttrs: function getAttrs(node) {
            var _node$textContent;

            if (!isElementDomNode(node)) {
              return false;
            }

            var href = node.getAttribute('href');

            var auto = node.hasAttribute(AUTO_ATTRIBUTE) || _this.options.autoLinkRegex.test((_node$textContent = node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : '');

            return _objectSpread(_objectSpread({}, extra.parse(node)), {}, {
              href: href,
              auto: auto
            }, getTargetObject(node.getAttribute('target')));
          }
        }].concat(_toConsumableArray((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])),
        toDOM: function toDOM(node) {
          var _omitExtraAttributes = omitExtraAttributes(node.attrs, extra);

          _omitExtraAttributes.auto;
          _omitExtraAttributes.target;

          var rest = _objectWithoutProperties(_omitExtraAttributes, _excluded);

          var auto = node.attrs.auto ? _defineProperty({}, AUTO_ATTRIBUTE, '') : {};
          var rel = 'noopener noreferrer nofollow';

          var attrs = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, extra.dom(node)), rest), {}, {
            rel: rel
          }, auto), getTargetObject(node.attrs.target));

          return ['a', attrs, 0];
        }
      });
    }
  }, {
    key: "onSetOptions",
    value: function onSetOptions(options) {
      if (options.changes.autoLink.changed) {
        var _this$createSuggester = this.createSuggesters(),
            _this$createSuggester2 = _slicedToArray(_this$createSuggester, 1),
            newSuggester = _this$createSuggester2[0];

        if (options.changes.autoLink.value === true && newSuggester) {
          this.store.addSuggester(newSuggester);
        }

        if (options.changes.autoLink.value === false) {
          this.store.removeSuggester(this.name);
        }
      }
    }
    /**
     * Add a handler to the `onActivateLink` to capture when .
     */

  }, {
    key: "shortcut",
    value: function shortcut(_ref) {
      var tr = _ref.tr;
      var selectedText = '';
      var _tr$selection = tr.selection,
          from = _tr$selection.from,
          to = _tr$selection.to,
          empty = _tr$selection.empty,
          $from = _tr$selection.$from;
      var expandedSelection = false;
      var mark = getMarkRange($from, this.type); // When the selection is empty, expand it to the active mark

      if (empty) {
        var selectedWord = mark !== null && mark !== void 0 ? mark : getSelectedWord(tr);

        if (!selectedWord) {
          return false;
        }

        selectedText = selectedWord.text;
        from = selectedWord.from;
        to = selectedWord.to;
        expandedSelection = true;
      }

      if (from === to) {
        return false;
      }

      if (!expandedSelection) {
        selectedText = tr.doc.textBetween(from, to);
      }

      this.options.onActivateLink(selectedText);
      this.options.onShortcut({
        activeLink: mark ? {
          attrs: mark.mark.attrs,
          from: mark.from,
          to: mark.to
        } : undefined,
        selectedText: selectedText,
        from: from,
        to: to
      });
      return true;
    }
    /**
     * Create or update the link if it doesn't currently exist at the current
     * selection or provided range.
     */

  }, {
    key: "updateLink",
    value: function updateLink(attrs, range) {
      var _this2 = this;

      return function (props) {
        var tr = props.tr;
        var selectionIsValid = isTextSelection(tr.selection) && !isSelectionEmpty(tr.selection) || isAllSelection(tr.selection) || isMarkActive({
          trState: tr,
          type: _this2.type
        });

        if (!selectionIsValid && !range) {
          return false;
        }

        tr.setMeta(_this2.name, {
          command: UPDATE_LINK,
          attrs: attrs,
          range: range
        });
        return updateMark({
          type: _this2.type,
          attrs: attrs,
          range: range
        })(props);
      };
    }
    /**
     * Select the link at the current location.
     */

  }, {
    key: "selectLink",
    value: function selectLink() {
      return this.store.commands.selectMark.original(this.type);
    }
    /**
     * Remove the link at the current selection
     */

  }, {
    key: "removeLink",
    value: function removeLink(range) {
      var _this3 = this;

      return function (props) {
        var tr = props.tr;

        if (!isMarkActive(_objectSpread({
          trState: tr,
          type: _this3.type
        }, range))) {
          return false;
        }

        return removeMark({
          type: _this3.type,
          expand: true,
          range: range
        })(props);
      };
    }
    /**
     * Create the paste rules that can transform a pasted link in the document.
     */

  }, {
    key: "createPasteRules",
    value: function createPasteRules() {
      return [{
        type: 'mark',
        regexp: this.options.autoLinkRegex,
        markType: this.type,
        getAttributes: function getAttributes(url, isReplacement) {
          return {
            href: getMatchString(url),
            auto: !isReplacement
          };
        }
      }];
    }
  }, {
    key: "createSuggesters",
    value: function createSuggesters() {
      var _this4 = this;

      if (!this.options.autoLink) {
        return [];
      } // Keep track of this to prevent multiple updates which prevent history from
      // working


      var cachedRange;
      var suggester = {
        name: this.name,
        matchOffset: 0,
        supportedCharacters: /$/,
        char: this.options.autoLinkRegex,
        priority: ExtensionPriority.Lowest,
        caseInsensitive: true,
        disableDecorations: true,
        appendTransaction: true,
        checkNextValidSelection: function checkNextValidSelection($pos, tr) {
          var _cachedRange;

          var range = getMarkRange($pos, _this4.type);

          if (!range || ((_cachedRange = cachedRange) === null || _cachedRange === void 0 ? void 0 : _cachedRange.from) === $pos.pos && cachedRange.to === range.to) {
            return;
          }

          if (!range.mark.attrs.auto) {
            return;
          }

          var mark = range.mark,
              to = range.to,
              text = range.text;

          var href = _this4.buildHref(text);

          if (mark.attrs.href === href) {
            return;
          } // The helpers to use here.


          var getSuggestMethods = _this4.store.helpers.getSuggestMethods; // Using the chainable commands so that the selection can be preserved
          // for the update.

          var _this$store$chain = _this4.store.chain(tr),
              updateLink = _this$store$chain.updateLink,
              removeLink = _this$store$chain.removeLink;

          var _getSuggestMethods = getSuggestMethods(),
              findMatchAtPosition = _getSuggestMethods.findMatchAtPosition;

          var selection = tr.selection; // Keep track of the last removal.

          cachedRange = {
            from: $pos.pos,
            to: to
          }; // Remove the link

          removeLink(cachedRange).tr(); // Make sure the selection gets preserved otherwise the cursor jumps
          // around.

          preserveSelection(selection, tr); // Check for active matches from the provided $pos

          var match = findMatchAtPosition($pos, _this4.name);

          if (match) {
            var _range = match.range,
                _text = match.text;
            updateLink({
              href: _this4.buildHref(_text.full),
              auto: true
            }, _range).tr();
          }
        },
        onChange: function onChange(details, tr) {
          var selection = tr.selection;
          var text = details.text,
              range$1 = details.range,
              exitReason = details.exitReason,
              setMarkRemoved = details.setMarkRemoved;

          var href = _this4.buildHref(text.full); // Using the chainable commands so that the selection can be preserved
          // for the update.


          var chain = _this4.store.chain(tr);

          var getSuggestMethods = _this4.store.helpers.getSuggestMethods;

          var _getSuggestMethods2 = getSuggestMethods(),
              findMatchAtPosition = _getSuggestMethods2.findMatchAtPosition;
          /** Remove the link at the provided range. */


          var remove = function remove() {
            var _markRange; // Call the command to use a custom transaction rather than the current.


            var markRange;

            var _iterator = _createForOfIteratorHelper(range(range$1.from, range$1.to)),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var pos = _step.value;
                markRange = getMarkRange(tr.doc.resolve(pos), _this4.type);

                if (markRange) {
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            chain.removeLink((_markRange = markRange) !== null && _markRange !== void 0 ? _markRange : range$1).tr(); // The mark range for the position after the matched text. If this
            // exists it should be removed to handle cleanup properly.

            var afterMarkRange;

            var _iterator2 = _createForOfIteratorHelper(range(tr.selection.to, Math.min(tr.selection.$to.end(), tr.doc.nodeSize - 2))),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _pos = _step2.value;
                afterMarkRange = getMarkRange(tr.doc.resolve(_pos), _this4.type);

                if (afterMarkRange) {
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            if (afterMarkRange) {
              chain.removeLink(afterMarkRange).tr();
            }

            preserveSelection(selection, tr);
            var match = findMatchAtPosition(tr.doc.resolve(Math.min(range$1.from + 1, tr.doc.nodeSize - 2)), _this4.name);

            if (match) {
              chain.updateLink({
                href: _this4.buildHref(match.text.full),
                auto: true
              }, match.range).tr();
            } else {
              setMarkRemoved();
            }
          }; // Respond when there is an exit.


          if (exitReason) {
            var isInvalid = isInvalidSplitReason(exitReason);
            var isRemoved = isRemovedReason(exitReason);

            if (isInvalid || isRemoved) {
              try {
                remove();
              } catch (_unused) {
                // Errors here can be ignored since they can be caused by deleting
                // the whole document.
                return;
              }
            }

            return;
          }

          var value;

          var _iterator3 = _createForOfIteratorHelper(range(range$1.from, range$1.to)),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _value;

              var pos = _step3.value;
              value = getMarkRange(tr.doc.resolve(pos), _this4.type);

              if (((_value = value) === null || _value === void 0 ? void 0 : _value.mark.attrs.auto) === false) {
                return;
              }

              if (value) {
                break;
              }
            }
            /** Update the current range with the new link */

          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var update = function update() {
            chain.updateLink({
              href: href,
              auto: true
            }, range$1).tr();
            preserveSelection(selection, tr);
          }; // Update when there is a value


          if (!value) {
            update();
            return;
          } // Do nothing when the current mark is identical to the mark that would be created.


          if (value.from === range$1.from && value.to === range$1.to && value.mark.attrs.auto && value.mark.attrs.href === href) {
            return;
          }

          update();
        }
      };
      return [suggester];
    }
    /**
     * Track click events passed through to the editor.
     */

  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this5 = this;

      return {
        clickMark: function clickMark(event, clickState) {
          var markRange = clickState.getMark(_this5.type);

          if (!markRange) {
            return;
          }

          var attrs = markRange.mark.attrs;

          var data = _objectSpread(_objectSpread({}, attrs), markRange); // If one of the handlers returns `true` then return early.


          if (_this5.options.onClick(event, data)) {
            return true;
          }

          var handled = false;

          if (_this5.options.openLinkOnClick) {
            handled = true;
            var href = attrs.href;
            window.open(href, '_blank');
          }

          if (_this5.options.selectTextOnClick) {
            handled = true;

            _this5.store.commands.selectText(markRange);
          }

          return handled;
        }
      };
    }
    /**
     * The plugin for handling click events in the editor.
     *
     * TODO extract this into the events extension and move that extension into
     * core.
     */

  }, {
    key: "createPlugin",
    value: function createPlugin() {
      var _this6 = this;

      return {
        props: {
          handleClick: function handleClick(view, pos) {
            if (!_this6.options.selectTextOnClick && !_this6.options.openLinkOnClick) {
              return false;
            }

            var _view$state = view.state,
                doc = _view$state.doc,
                tr = _view$state.tr;
            var range = getMarkRange(doc.resolve(pos), _this6.type);

            if (!range) {
              return false;
            }

            if (_this6.options.openLinkOnClick) {
              var href = range.mark.attrs.href;
              window.open(href, '_blank');
            }

            if (_this6.options.selectTextOnClick) {
              var $start = doc.resolve(range.from);
              var $end = doc.resolve(range.to);
              var transaction = tr.setSelection(new TextSelection($start, $end));
              view.dispatch(transaction);
            }

            return true;
          }
        },
        appendTransaction: function appendTransaction(transactions, _oldState, state) {
          var transactionsWithLinkMeta = transactions.filter(function (tr) {
            return !!tr.getMeta(_this6.name);
          });

          if (transactionsWithLinkMeta.length === 0) {
            return;
          }

          transactionsWithLinkMeta.forEach(function (tr) {
            var trMeta = tr.getMeta(_this6.name);

            if (trMeta.command === UPDATE_LINK) {
              var range = trMeta.range,
                  attrs = trMeta.attrs;
              var selection = state.selection,
                  doc = state.doc;
              var _meta = {
                range: range,
                selection: selection,
                doc: doc,
                attrs: attrs
              };

              var _ref2 = range !== null && range !== void 0 ? range : selection,
                  from = _ref2.from,
                  to = _ref2.to;

              _this6.options.onUpdateLink(doc.textBetween(from, to), _meta);
            }
          });
        }
      };
    }
  }, {
    key: "buildHref",
    value: function buildHref(url) {
      return this.options.extractHref({
        url: url,
        defaultProtocol: this.options.defaultProtocol
      });
    }
  }]);

  return LinkExtension;
}(MarkExtension), (_applyDecoratedDescriptor(_class2.prototype, "shortcut", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "shortcut"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateLink", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "updateLink"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectLink", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "selectLink"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeLink", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "removeLink"), _class2.prototype)), _class2)) || _class);
/**
 * Extract the `href` from the provided text.
 *
 * @remarks
 *
 * This will return the `url` text with a `${defaultProtocol}//` or `mailto:` prefix if needed.
 */

function extractHref(_ref3) {
  var url = _ref3.url,
      defaultProtocol = _ref3.defaultProtocol;
  var startsWithProtocol = /^((?:https?|ftp)?:)\/\//.test(url); // This isn't 100% precise because we allowed URLs without protocol
  // For example, userid@example.com could be email address or link http://userid@example.com

  var isEmail = !startsWithProtocol && url.includes('@');

  if (isEmail) {
    return "mailto:".concat(url);
  }

  return startsWithProtocol ? url : "".concat(defaultProtocol, "//").concat(url);
}

export { LinkExtension, extractHref };